import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AgileIntegrationService } from 'src/app/core/services/agile/agile-integration.service';
import { MyTicketCinejoy, MyTicketsResponse } from '../../spotlight/models/my-ticket-cinejoy/my-ticket-cinejoy.model';
import { MyTicketScreeningParties } from '../../spotlight/models/my-ticket-screening-parties/my-ticket-screening-parties.model';
import * as moment from 'moment-timezone';
import { Profile } from 'src/app/features/passport/models/profile.model';
import { Constants } from 'src/app/core/models/common.models';
import { MatDialog } from '@angular/material/dialog';
import { TicketAssingRemoveComponent } from './ticket-assign-remove-popup/ticket-assign-remove-popup.component';
import { parse } from 'path';
@Component({
  selector: 'app-my-tickets',
  templateUrl: './my-tickets.component.html',
  styleUrls: ['./my-tickets.component.css'],
})
//my ticket component
export class MyTicketsComponent implements OnInit {
  spotlightsTickets: MyTicketCinejoy[] = new Array();
  showcaseTickets: MyTicketCinejoy[] = new Array();
  subscriptions:MyTicketCinejoy[]= new Array();
  screeningPartiesTickets: MyTicketScreeningParties[] = new Array();
  isLoading = false;
  timezone:any;
  timezoneSpotlight: any
  userData: any;
  ticket:any;
  isAssignTicketActive:boolean=false;
  constructor(
    private agileIntegration: AgileIntegrationService,
    public activeModal: NgbActiveModal,
    public dialog: MatDialog,
  ) {
    this.fetchTickets();
  }

  ngOnInit(): void {
    var zone = moment.tz.guess();
    this.timezone = moment.tz(zone).format("z");
    this.userData = JSON.parse(localStorage.getItem(Constants.localStorageKeys.PASSPORT_PROFILE) || '{}');
  }

 // All dates returns in Pacific time from Agiletix for creatics platform

  //Following returns Pacific Time Zone Value (-08:00 / -07.00)
  // pacificTimezone(date:any){

  //   const time = moment(date).tz("America/Los_Angeles").format('Z')
  //   var pacificTZ = time
  //   return pacificTZ;

  // }

pacificTimezone(date: any): number {
  const userTimezone = moment.tz.guess();
  const userTime = moment.utc(date).tz(userTimezone);
  return userTime.valueOf();
}

  //Following function returns user's current timezone name
  userTimezoneName(date:any){

    const time = moment(date).tz("America/Los_Angeles").format('Z')
    var pacificTZ = date+time
    var newDate = new Date(pacificTZ).toString();
    var zone = moment.tz.guess();
    var timezoneName = moment(newDate).tz(zone).format('z')
    return timezoneName;
  }

  //Following function returns user's current timezone name for Screening Party
  userTimezoneNameSP(date:any){

    var zone = moment.tz.guess();
    var newDate = new Date(date).toString()
    var timezoneName = moment(newDate).tz(zone).format('z')
    return timezoneName;
  }

  fetchTickets(): void {
    this.isLoading = true;
    this.agileIntegration.fetchTickets().subscribe(
      (response: MyTicketsResponse) => {
        this.isLoading = false;
        let tickets = response.agiletixEvents ? response.agiletixEvents : [];

        tickets = tickets.map(ticket => {
          if (ticket.purchaseSource && ticket.purchaseSource === 'STRIPE') {
            ticket.guestUsernames = (ticket.guestUsers && ticket.guestUsers.length)
              ? ticket.guestUsers.map((user: Profile) => user.firstName)
              : []
          }
          this.ticket=ticket;
          return ticket;
        });

        this.spotlightsTickets = tickets.filter(
          (ticket) =>
            ticket.type !== undefined &&
            ticket.type !== null &&
            ticket.type.toLowerCase().includes('spotlight')
        );

        this.showcaseTickets = tickets.filter(
          (ticket) =>
            ticket.type !== undefined &&
            ticket.type !== null &&
            ticket.type.toLowerCase().includes('showcase')
        );
        this.subscriptions = tickets.filter(
          (ticket) =>
            ticket.purchaseTransactionType==='SUBSCRIPTION_ALL'||
            ticket.purchaseTransactionType==='SUBSCRIPTION_SPOTLIGHT'||
            ticket.purchaseTransactionType==='SUBSCRIPTION_SHOWCASE'
            
            );
        this.showcaseTickets = this.showcaseTickets.sort((a, b) =>
          a.Name.localeCompare(b.Name, 'en', { numeric: true })
        );
        this.screeningPartiesTickets = response.screeningParties ? response.screeningParties : [];
        this.screeningPartiesTickets.forEach((ticket) => {
          if (ticket.meetingDateTime) {
              ticket.meetingDateTime = new Date(
                ticket.meetingDateTime
              );
          }
        });

      },
      (error) => {
        this.isLoading = false;
        console.log(error);
      }
    );
  }

  closeModal(): void {
    this.activeModal.close();
  }

  selectTicket(type, ticket): void {
    console.log(ticket)
    let url;
    switch (type) {
      case 'showcase':
        url = `/cinejoy/showcase/moviepage/${ticket.ParentID}/${this.getmovieName(ticket.Name)}/2025`;
        break;
      case 'spotlights':
        url =
          '/cinejoy/premiere/more-info/' +
          ticket.ParentID +
          '/' +
          ticket.Name.replace(/[\s?]/g, '-');
        break;
      case 'screeningParties':
        url = '/cinejoy/screening-parties/join';
        break;
      case 'subscription':{
        if(ticket.purchaseTransactionType==='SUBSCRIPTION_ALL'){
          url= '/cinejoy/how-to'
        }
        else if(ticket.purchaseTransactionType==='SUBSCRIPTION_SPOTLIGHT'){
          url='/cinejoy/premiere/lineup/'
        }
        else{
          url='/cinejoy/showcase/'
        }
        break;
      }
    }
    location.href = url;
  }

  getmovieName(moviename){
    let name = moviename.replace(/[\s?]/g, '-');
    return name;
  }

  openAssignRemoveTicketDialog(ticket): void {
    this.activeModal.close();
    let userDetails= JSON.parse(localStorage.getItem('passportProfile'));
    let hostuserId = userDetails.userId;
    console.log(ticket,"---------------ticket response ----------");
    this.dialog.open(TicketAssingRemoveComponent, {
      panelClass: 'pre-schedule-modalbox',
      width: '600px',
      height: '70%',
      data: {
        event:ticket.name,
        tickets: ticket.remainingHostTicketCount,
        paymentSessionId:ticket.paymentSessionId,
        hostId:hostuserId
      }
    }).afterClosed().subscribe((res) => {
      console.log('===== dialog closed with response: ', res);
    })
  }
}
